<template>
  <article class="single-project container" v-if="loaded" :class="projectViewMode" :ref="'projectArticle'">
      <div v-if="projectViewMode == 'full'">
        <button @click="closeFull()" v-if="viewMode" class="close-project"><close-icon/></button>
        <h1>{{this.projectData.title.rendered}}</h1>

        <vue-plyr v-if="this.projectData.acf.video_file" :options="settings.plyrDefault">
        <video :poster="posterImage" :src="this.projectData.acf.video_file.url" autoplay playsinline>
            <source :src="this.projectData.acf.video_file.url" :type="this.projectData.acf.video_file.mime_type" size="1024">
        </video>
        </vue-plyr>

        <masonry
        :cols="2"
        :gutter="30"
        class="masonry-gallery"
        >
        <figure v-for="(afbeelding, index) in this.projectData.acf.afbeeldingen_galerij" v-bind:key="index">
            <ZoomImage
            :src="afbeelding.sizes.large"
            />
        </figure>
        </masonry>
    </div>
    <div v-else>
        <div :ref="'projectTile'" @click="setToFull()"  class="click">
            <img :src="this.projectData.better_featured_image.media_details.sizes['post-thumbnail'].source_url" v-if="viewMode == 'grid'">
            <h2>{{this.projectData.title.rendered}}</h2>
        </div>
        <!-- <router-link :to="'/project/' + this.projectData.slug">
          <img :src="this.projectData.better_featured_image.media_details.sizes['post-thumbnail'].source_url" v-if="viewMode == 'grid'">
          <h2>{{this.projectData.title.rendered}}</h2>
        </router-link> -->
    </div>

  </article>
</template>

<script>
import { settings } from '../variables.js'
import ZoomImage from '@/components/ZoomImage.vue'

export default {
  name: 'project',
  components: { ZoomImage },
  props: ['projectData', 'viewMode', 'projectView'],
  data () {
    return {
      slug: this.$route.params.slug,
      project: this.projectData,
      settings: settings,
      animationSpeed: 321,
      projectViewMode: this.projectView,
      rect: {}
    }
  },
  computed: {
    loaded () {
      return !(Object.entries(this.projectData).length === 0 && this.projectData.constructor === Object)
    },
    posterImage () {
      return this.projectData.acf.video_file.sizes ? this.projectData.acf.video_file.sizes.large : ''
    }
  },
  methods: {
    setToFull () {
      let element = this.$refs.projectArticle
      this.rect = this.$refs.projectTile.getBoundingClientRect()
      element.style.left = this.rect.left + 'px'
      element.style.top = this.rect.top + 'px'
      element.style.width = this.rect.width + 'px'
      element.style.height = this.rect.height + 'px'
      element.style.position = 'fixed'
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'

      setTimeout(() => {
        element.style.transitionDuration = (this.animationSpeed / 1000) + 's'
        element.style.left = '0px'
        element.style.top = '0px'
        element.style.width = '100vw'
        element.style.height = '100vh'
      }, 10)

      this.projectViewMode = 'full'
    },
    closeFull () {
      let element = this.$refs.projectArticle
      element.style.left = this.rect.left + 'px'
      element.style.top = this.rect.top + 'px'
      element.style.width = this.rect.width + 'px'
      element.style.height = this.rect.height + 'px'
      element.style.opacity = 0.5
      document.getElementsByTagName('body')[0].style.overflow = 'unset'

      setTimeout(() => {
        element.style.position = 'relative'
        element.style.left = 'unset'
        element.style.top = 'unset'
        element.style.width = 'unset'
        element.style.height = 'unset'
        element.style.transitionDuration = 'unset'
        this.projectViewMode = 'overview'
        element.style.opacity = 1
      }, this.animationSpeed)
    }
  }
}
</script>

<style lang="scss">
.single-project {
  // transition: all .7s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;
  transition-timing-function: cubic-bezier(0.08, 0.69, 0.2, 0.99);
  position: relative;
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;
  // background-color: #fff;
  opacity: 1;

  &>div {
    max-width: 1024px;
    margin: 0 auto;
  }

  .close-project {
      position: fixed;
      bottom: .3em;
      right: .2em;
      appearance: none;
      border: 0;
      cursor: pointer;
      font-size: 2em;
      color: #2c3e50;
      background-color: #fff;
      outline: none;
      z-index: 500;

      @media all and (min-width: 768px) {
        position: absolute;
        bottom: initial;
        top: .3em;
      }
  }

  img {
    animation: fade-in 0.4s forwards 1;
  }
}

li .single-project.full {
    max-width: 100vw;
    overflow-y: auto;
    z-index: 999;
    background-color: #fff;

    h1 {
      text-align: center;
    }
}

video {
  width: 100%;
}
figure {
  padding: 0;
  margin: 0 0 30px;

  img {
    max-width: 100%;
    display: block;
  }
}
.masonry-gallery {
  margin-top: 2em;
}

@keyframes fade-in {
  from {opacity: 0;}
  to {opacity: 1;}
}
</style>
